import { defineComponent as _defineComponent } from 'vue'
import {ref, watch} from "vue";
import ButtonCommon from "../components/buttons/ButtonCommon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowMore',
  props: {
    maxHeight: null,
    showMoreText: null,
    showLessText: null
  },
  setup(__props: any) {

const props = __props as {
  maxHeight: number;
  showMoreText?: string;
  showLessText?: string;
};



const contentRef = ref();
const isExpanded = ref(false);
const showMoreButtonVisible = ref(false);
const contentHeight = ref(0);

const resizeObserver = new ResizeObserver(() => {
  contentHeight.value = contentRef.value?.offsetHeight;
  showMoreButtonVisible.value = contentHeight.value > props.maxHeight;
});

watch(contentRef, (newVal, oldVal) => {
  if (oldVal) {
    resizeObserver.unobserve(oldVal);
  }
  if (newVal) {
    resizeObserver.observe(newVal);
  }
});

return { __sfc: true,props, contentRef, isExpanded, showMoreButtonVisible, contentHeight, resizeObserver, ButtonCommon }
}

})